// 账号类型
export enum AccountType {
  Normal = 'normal',
  Internal = 'internal',
}

// 套餐类型: 1正式，2试用，3内部
export enum UserPlanType {
  Official = 1,
  Trial = 2,
  Internal = 3,
}

// 套餐功能范围：1可玩，2视频，3可玩+视频
export enum UserPlanScope {
  Playable = 1,
  Video = 2,
  PlayableAndVideo = 3,
}
export enum PermissionKey {
  Gm = 'gm',
  Dm = 'dm',
  Assets = 'assets',
  Ve = 've',
  Vrec = 'vrec',
  Ps = 'ps',
  VeBatch = 've.batch',
  AI = 'ai',
  InternalAccount = 'internal_account',
  AIGC = 'aigc',
  Insights = 'insights',
  VeTpl = 've.tpl',
  // 视频模版仅限内部账号和ve.tpl权限使用
  InternalTpl = 'internal_tpl',
  // 当前处于com域名下， 视频ai功能国内不能使用
  International = 'international',
  // 有购买套餐权限
  GrantPlan = 'grant_plan',
}

/**
 * 用量类型
 */
export enum UsageType {
  /** 视频点数 */
  RenderVideo = 'video_credits',
  /** 可玩下载/推送 */
  DownloadPush = 'download_push',
  /** 存储空间 */
  Storage = 'storage',
}

/**
 * 账单状态
 */
export enum BillStatus {
  /** 已结清 */
  Settled = 1,
  /** 未结清 */
  Unresolved = 2,
  /** 未结算 */
  Unsettled = 3,
}
